import type {FormEvent} from 'react'
import {Input} from '@freckle/educator-entities/ts/common/components/base/input'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {SpinnerOverlay} from '@freckle/educator-materials/ts/components/spinner'
import {H1} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {CenteredPage} from '@freckle/school/ts/common/components/common/centered-page'
import {form, formGroup} from './set-password.module.scss'

type Props = {
  password?: string
  passwordConfirm?: string
  onChangePassword: (password: string) => void
  onChangePasswordConfirm: (passwordConfirm: string) => void
  onSubmit: (e: FormEvent<HTMLFormElement>) => void
  loading: boolean
}

export default function SetPassword(props: Props) {
  const {t} = useSafeTranslation()
  const {password, passwordConfirm, onChangePassword, onChangePasswordConfirm, onSubmit, loading} =
    props

  if (loading) {
    return <SpinnerOverlay />
  }

  return (
    <CenteredPage>
      <H1>{t('SET_PASSWORD_PAGE_TITLE')}</H1>
      <form action="" method="post" onSubmit={onSubmit} className={form}>
        <div className={formGroup}>
          <Input
            className="form-control"
            name="password"
            onChange={onChangePassword}
            type="password"
            placeholder={t('SET_PASSWORD_PAGE_NEW_PASSWORD_PLACEHOLDER_TEXT')}
            autoCorrect="off"
            required
            value={password}
            dataTest="set-password-password-input"
          />
        </div>
        <div className={formGroup}>
          <Input
            className="form-control"
            name="password-confirm"
            onChange={onChangePasswordConfirm}
            type="password"
            placeholder={t('SET_PASSWORD_PAGE_CONFIRM_PASSWORD_PLACEHOLDER_TEXT')}
            autoCorrect="off"
            required
            value={passwordConfirm}
            dataTest="set-password-password-confirm-input"
          />
        </div>
        <Button style="primary" type="submit" dataTest="set-password-submit-btn">
          {t('SET_PASSWORD_SUBMIT_BUTTON_TEXT')}
        </Button>
      </form>
    </CenteredPage>
  )
}
